import React, {useEffect, useState, useRef} from 'react';
import { useReactToPrint} from 'react-to-print'
import '../App.css';
import Bodyheaderloged from './bodyheaderloged'
import { jsPDF } from "jspdf";
import Boleta from './boleta'
import { Button }  from 'bootstrap';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom'

function Bodyfinalbuy(props)
{
    const [authcode, setAuthCode] = useState('')

    const navigate = useNavigate();

    useEffect(() => {
        let authsincoma = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').toString().replace('"', '')
        setAuthCode(authsincoma.replace('"', ''))
    }, []);
    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerRegister'>
                <Bodyheaderloged/>
            </div>
            <div>
                
            </div>

            <div className='sshbodyappContainerLoginForm'>
                <Boleta id='pdf'/> 
            </div>
                
            <div>
              
            </div>

        </div>            
    )
}
export default Bodyfinalbuy

